import core from "@/helpers/client";
const productSalePricePromotionService = {  
    async getProductSalePricePromotionListAsync(params) {
      const result = await core.fetch(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/salepricepromotion`,
        params
      )
      return result
    },     
    async getPromotionPriceWithSalePricePromotionByPromotionIdAsync(id) {
      const result = await core.fetch(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/salepricepromotion/${id}`
      );
      return result;
    },
    async SearchProductSkuIncludeProductSalePricePromotionAsync(model) {
      const result = await core.create(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/salepricepromotion/searchprice`,
        model
      )
      return result
    }, 
    async getProductSalePricePromotionBySkuCodeAsync(id) {
      const result = await core.fetch(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/salepricepromotion/skucodeofm/${id}`
      );
      return result;
    },
    async updateProductSalePricePromotionAsync(model) {
      const result = await core.update(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/salepricepromotion`,
        model
      );
      return result;
    },
}
export default productSalePricePromotionService